import moment from "moment";

const NewTimeFormatter = (date) => {
  return moment(date).format("LL");
};

export default NewTimeFormatter;
